import { render, staticRenderFns } from "./query_supplyment.vue?vue&type=template&id=4677dbdf&scoped=true"
import script from "./query_supplyment.vue?vue&type=script&lang=js"
export * from "./query_supplyment.vue?vue&type=script&lang=js"
import style0 from "./query_supplyment.vue?vue&type=style&index=0&id=4677dbdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4677dbdf",
  null
  
)

export default component.exports